import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router'
import { typography } from '../styles'

const StyledLink = styled(Link)`
  display: block;
  ${ typography.noDecoration }
  ${ props => props.pink ? typography.pink : typography.blue }
  ${ props => props.light ? '' : typography.bold }
  &:hover {
    text-decoration: underline;
  }
`

const NavLink = ({light, pink, ...props}) => <StyledLink {...props}/>

export default NavLink



/** WEBPACK FOOTER **
 ** ./src/components/NavLink.js
 **/